<template>
    <h1>{{ $t("success.doneMultiVideo") }}</h1>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "MultiVideoProjectSuccess"
});
</script>

<style scoped>
h1 {
    margin-top: 20px;
    margin-bottom: 20px;
    color: var(--screenTextColor);
}
</style>
